import httpClient from './httpClient'

export default {
  async getPlaylists() {
    let ret = await httpClient.get('/playlists')
    return ret
  },
  async getPlaylist(id) {
    let ret = await httpClient.get(`/playlists/${id}`)
    return ret
  },
  async createPlaylist(playlist) {
    let ret = await httpClient.post('/playlists', playlist)
    return ret
  },
  async updatePlaylist(playlist, playlistId) {
    let ret = await httpClient.put(`/playlists/${playlistId}`, playlist)
    return ret
  },
  async removePlaylist(playlistId) {
    let ret = await httpClient.delete(`/playlists/${playlistId}`)
    return ret
  },
  async updatePlaylistVideos(playlist, playlistId) {
    let ret = await httpClient.post(`/playlists/${playlistId}/videos`, playlist)
    return ret
  },
  async removePlaylistVideos(playlistId, videoId) {
    let ret = await httpClient.delete(
      `/playlists/${playlistId}/videos/${videoId}`
    )
    return ret
  },
  async getPlaylistVideos(playlistId) {
    let ret = await httpClient.get(`/playlists/${playlistId}/videos`)
    return ret
  },
}
